const initSitemapToggle = () => {
	const trigger = document.querySelector('[data-sitemap-trigger]');
	const panel = document.querySelector('[data-sitemap-panel]');
	const closeBtn = document.querySelector('[data-sitemap-close]');
	if (!trigger || !panel) return;

	const handleOpen = () => {
		trigger.setAttribute('aria-expanded', 'true');
		panel.setAttribute('aria-hidden', 'false');
		panel.style.maxHeight = panel.scrollHeight + 'px';
		setTimeout(() => {
			window.scrollTo({ top: panel.offsetTop, behavior: 'smooth' });
		}, 300);
	};

	const handleClose = () => {
		trigger.setAttribute('aria-expanded', 'false');
		panel.setAttribute('aria-hidden', 'true');
		panel.style.maxHeight = '0px';
	};

	trigger.addEventListener('click', () => {
		const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
		if (isExpanded) {
			handleClose();
		} else {
			handleOpen();
		}
	});

	if (closeBtn) {
		closeBtn.addEventListener('click', handleClose);
	}
};

export { initSitemapToggle };
